import React, { useEffect, useRef } from "react";
//
import Screen from "../containers/ConnectedScreen";
import Button from "./Button";
import Message from "./Message";
import CustomSelect from "./CustomSelect";
import Tabs from "./Tabs";
import ModelItemContainer from "./ModelItemContainer";
import PremiumAlert from "../containers/PremiumAlert";

export const MODELS_TABS = [
  { name: "Online", value: "online" },
  { name: "Favorites", icon: "favorite_border", value: "favorite" },
  { name: "Videos", icon: "play_circle_outline", value: "videos" },
];

export default function ModelListScreen({
  areaId,
  city,
  goTo,
  premiumAlert,
  infoText,
  infoIcon,
  orderRaw,
  setArea,
  setOrderBy,
  models,
  modelsOffline = [],
  ...rest
}) {
  if (infoText) {
    return renderScreen(
      { ...rest, city, modelsOffline, goTo },
      <Message {...{ icon: infoIcon, text: infoText }} />
    );
  }

  return renderScreen(
    { ...rest, city, modelsOffline, goTo },
    renderModels(
      goTo,
      premiumAlert,
      models,
      modelsOffline,
      areaId,
      city,
      setArea,
      orderRaw,
      setOrderBy
    )
  );
}

let lastScrollTop = 0;

function handleScroll(ev) {
  lastScrollTop = ev.target.scrollTop;
}

function renderScreen(
  {
    city,
    selectedTab,
    modelsCount,
    filtersCount,
    isActive,
    genderName,
    goTo,
    modelsOffline,
    setModelsVisible,
  },
  content
) {
  const scrollRef = useRef(null);

  useEffect(() => {
    scrollRef.current.addEventListener("scroll", handleScroll);
    return () => {
      scrollRef.current.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (lastScrollTop) {
      scrollRef.current.scrollTop = lastScrollTop;
    }
  }, []);

  const goToFilters = () => {
    lastScrollTop = 0;
    goTo("filters");
  };

  const handleTabChange = (tab) => setModelsVisible(tab);

  let total = modelsCount;

  if (!city.matured) {
    total += modelsOffline.length;
  }

  return (
    <Screen
      {...{
        title: `${total} ${genderName === "Female" ? "escort" : genderName}s`,
        isActive,
        className: "screen--models",
        noFooter: true,
        large: true,
        full: true,
        scrollRef,
      }}
    >
      <div className="screen__tabs u-clearfix">
        <Tabs
          items={MODELS_TABS}
          selected={selectedTab}
          onChange={handleTabChange}
          className="u-fl"
        />
        {selectedTab === "online" && (
          <Button
            title={filtersCount ? `FILTERS (${filtersCount})` : "FILTERS"}
            tiny
            mod={filtersCount > 0 ? "basic" : []}
            className="u-fr"
            onClick={goToFilters}
          />
        )}
      </div>
      {content}
    </Screen>
  );
}

function renderToolbar(areaId, city, setArea, orderRaw, setOrderBy) {
  if (!setOrderBy) {
    return null;
  }

  const areas = city.areas.map(({ id, name }) => ({
    name,
    value: id,
  }));

  if (areas.length) {
    areas.unshift({ name: "Select area", value: "" });
  }

  return (
    <div className="u-mb-small u-clearfix">
      {areas.length > 0 && (
        <div className="u-fl form">
          <CustomSelect
            value={areaId || ""}
            onChange={(ev) => setArea(ev.target.value)}
            options={areas}
          />
        </div>
      )}
      {Boolean(setOrderBy) && (
        <div className="u-fr form">
          <CustomSelect
            value={orderRaw}
            onChange={(ev) => setOrderBy(ev.target.value)}
            options={[
              { name: "Default", value: "" },
              { name: "Popular", value: "rating_desc" },
              { name: "Price (high)", value: "price_desc" },
              { name: "Price (low)", value: "price_asc" },
              { name: "Rating", value: "score_desc" },
              { name: "Distance", value: "distance_asc" },
            ]}
          />
        </div>
      )}
    </div>
  );
}

function renderModels(
  goTo,
  premiumAlert,
  models,
  offline,
  areaId,
  city,
  setArea,
  orderRaw,
  setOrderBy
) {
  const hideOffline = Boolean(premiumAlert);

  return (
    <div>
      {renderToolbar(areaId, city, setArea, orderRaw, setOrderBy)}
      {renderModelList(models)}
      {hideOffline && <PremiumAlert {...{ goTo, text: premiumAlert }} />}
      {!hideOffline && offline.length > 0 && renderModelList(offline)}
    </div>
  );
}

function renderModelList(models) {
  return (
    <ul className="o-layout o-layout--small model-cards">
      {models.map((model) => (
        <ModelItemContainer key={model.id} model={model} />
      ))}
    </ul>
  );
}
